import React from "react";
import CommandForm from "./forms/CommandForm";
import { CharacterSheetContext } from "../contexts/CharacterSheetContext";
import { RuleModule } from "../classes/RuleModule";
import RuleModuleSection from "./RuleModuleSection";
import RevisionSection from "./RevisionSection";
import AddRuleModuleForm from "./forms/AddRuleModuleForm";
import { RulesContext } from "../contexts/RulesContext";
import { RuleModuleContext } from "../contexts/RuleModuleContext";
import { AlertLevel } from "../types/AlertTypes";
import XPSection from "./XPSection";

export default () => {
  const { allRuleModuleSections } = React.useContext(RulesContext);
  const [showSources, setShowSources] = React.useState(true);
  const [adminMode, setAdminMode] = React.useState(false);
  const [characterEditMode, setCharacterEditMode] = React.useState(true);
  const [showAllAlerts, setShowAllAlerts] = React.useState(false);
  const [alertLevel, setAlertLevel] = React.useState(AlertLevel._5_VERBOSE);

  const toggleShowingSources = () => {
    setShowSources(!showSources);
  };

  const toggleAdminMode = () => {
    setAdminMode(!adminMode);
  };

  const toggleCharacterEditMode = () => {
    setCharacterEditMode(!characterEditMode);
  };

  const toggleShowAllAlerts = () => {
    setShowAllAlerts(!showAllAlerts);
  };

  const changeAlertLevel = (event: any) => {
    setAlertLevel(event.target.value);
  };

  const showSourcesButtonText = showSources ? "Hide Sources" : "Show Sources";
  const adminModeText = adminMode ? "User Mode" : "Admin Mode";
  const characterEditModeText = characterEditMode ? "Readonly" : "Edit Mode";
  const showAllAlertsText = showAllAlerts
    ? "Temporary Alerts"
    : "Show Alert History";
  const showSourcesButton = (
    <button
      className="inline-button button-spacing"
      data-test="toggleShowingSources"
      onClick={toggleShowingSources}
    >
      {showSourcesButtonText}
    </button>
  );
  const adminModeButton = (
    <button
      className="inline-button button-spacing"
      data-test="toggleAdminMode"
      onClick={toggleAdminMode}
    >
      {adminModeText}
    </button>
  );
  const characterEditModeButton = (
    <button
      className="inline-button button-spacing"
      data-test="toggleCharacterEditMode"
      onClick={toggleCharacterEditMode}
    >
      {characterEditModeText}
    </button>
  );
  const showAllAlertsButton = (
    <button
      className="inline-button button-spacing"
      data-test="toggleShowAllAlerts"
      onClick={toggleShowAllAlerts}
    >
      {showAllAlertsText}
    </button>
  );

  const elements: JSX.Element[] = [];
  allRuleModuleSections().forEach(
    (section: RuleModule[], section_i: number) => {
      const sectionElements: JSX.Element[] = [];
      section.forEach((ruleModule: RuleModule, i: number) => {
        sectionElements.push(
          <RuleModuleContext.Provider
            value={ruleModule}
            key={`character-sheet-rule-module-section-${section_i}-${i}`}
          >
            <RuleModuleSection key={`rule-module-section-${section_i}-${i}`} />
          </RuleModuleContext.Provider>
        );
      });
      elements.push(
        <div
          key={`section-${section_i}`}
          className={`grid-rule-module-section section-${section_i}`}
        >
          {sectionElements}
          {adminMode && (
            <div className={"grid-container grid-container-width"}>
              <AddRuleModuleForm section_i={section_i} />
            </div>
          )}
        </div>
      );
    }
  );
  const ruleModuleSections = React.createElement(React.Fragment, {}, elements);
  return (
    <CharacterSheetContext.Provider
      value={{
        showSources,
        adminMode,
        characterEditMode,
        showAllAlerts,
        alertLevel,
      }}
    >
      <div className="game">
        <XPSection />
        <div className="grid-character-sheet">
          {ruleModuleSections}
          {/* TODO: dynamically assign section to command form */}
          <div className="section-misc">
            <CommandForm />
            <div className="double-height">
              <div>{showSourcesButton}</div>
              <div>{characterEditModeButton}</div>
              <div>{adminModeButton}</div>
              <div>{showAllAlertsButton}</div>
              <div className="revision-history">Alerting Level:</div>
              <select
                value={alertLevel}
                className="textCell inline-select inline-select-background"
                onChange={changeAlertLevel}
              >
                {[
                  "Critical Only",
                  "Errors",
                  "Rules and Limits",
                  "Side Effects",
                  "Action Log",
                  "Verbose",
                ].map((desc: string, i: number) => {
                  return (
                    <option value={i} key={`alert-level-${i}`}>
                      {desc}
                    </option>
                  );
                })}
              </select>
              <div className="revision-history">Character History:</div>
              <RevisionSection />
            </div>
          </div>
        </div>
      </div>
    </CharacterSheetContext.Provider>
  );
};
